import { useLocation, useNavigate } from "react-router-dom";

const Cartao = (props) => {
    const navegar = useNavigate()
    const rotaAtiva = useLocation()
    const diaSemana = {6: 'Domingo', 0: 'Segunda', 1: 'Terça', 2: 'Quarta', 3: 'Quinta', 4: 'Sexta', 5: 'Sábado'}
    const meses = {1: 'Janeiro', 2: 'Fevereiro', 3: 'Março', 4: 'Abril', 5: 'Maio', 6: 'Junho', 7: 'Julho', 8: 'Agosto', 9: 'Setembro', 10: 'Outubro', 11: 'Novembro', 12: 'Dezembro'};
    const feira = new Date(`${props.role.data.split('/')[2]}-${props.role.data.split('/')[1]}-${props.role.data.split('/')[0]}`).getDay()
    const local = props.locais.find(elemento => elemento.cep == props.role.cep && elemento.numero == props.role.numero)

    return(
        <div key={props.role.nome + props.role.id} className="snap-center shrink-0 bg-purple-50 text-black font-sans min-w-[73vw] max-w-[73vw] sm:min-w-[40vw] sm:max-w-[40vw] md:min-w-[34vw] md:max-w-[34vw] lg:min-w-[25vw] lg:max-w-[25vw] xl:min-w-[20vw] xl:max-w-[20vw] min-h-[63vh] max-h-[63vh] hsm:min-h-[60vh] hsm:max-h-[60vh] hmd:min-h-[53vh] hmd:max-h-[53vh] hlg:min-h-[45vh] hlg:max-h-[45vh] hxl:min-h-[38vh] hxl:max-h-[38vh] border-2 rounded-xl shadow-md hover:shadow-2xl hover:shadow-purple-200/50 duration-200 overflow-clip" onClick={() => {
            navegar(`/infolocal?${new URLSearchParams({ id: local.id, idRole: props.role.id, voltar: rotaAtiva.pathname }).toString()}`)
        }}>
            <img src={props.role.img} className='w-full h-2/6 object-cover' />
            <div className="flex flex-col gap-3 p-3">
                <div className="flex flex-row justify-between items-center">
                    <div className="font-bold max-w-[80%] whitespace-nowrap overflow-hidden text-ellipsis">{props.role.local}</div>
                    <div className="flex flex-row gap-1 items-center">
                        <div className="whitespace-nowrap text-sm">{local?.estrelas ?? null}</div>
                        {local?.estrelas ? <svg className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 20 20">
                            <path d="M10 15l-5.878 3.09 1.122-6.545L.487 6.91l6.562-.955L10 0l2.951 5.955 6.562.955-4.757 4.635 1.122 6.545z" />
                        </svg> : null}
                    </div>
                </div>
                <div className="flex justify-between items-center text-sm">
                  <div className=" whitespace-nowrap overflow-hidden text-ellipsis">{props.role.bairro}</div>
                  <div className="bg-orange-600 px-3 py-1 rounded-xl font-semibold text-purple-50 whitespace-nowrap">{props.role.distancia != undefined && props.role.distancia != 5653.6 ? 'Distancia ' + props.role.distancia + 'KM' : null}</div>
                </div>
                <div className="text-sm font-medium whitespace-nowrap overflow-hidden text-ellipsis">{props.role.nome}</div>
                <div className="flex justify-center gap-2">
                    {JSON.parse(props.role.subcategoria).map((item) => {
                        return(
                            <div className="text-xs border p-1 rounded-xl whitespace-nowrap">{item}</div>
                        )
                    })}
                </div>
                <div className="flex justify-around">
                    <div className="flex flex-col items-center">
                        <div className="bg-black text-white px-2 font-black text-xl">{diaSemana[feira]}</div>
                        <div className="font-black text-3xl">{props.role.data.split('/')[0]}</div>
                        <div className="text-xl">{meses[parseInt(props.role.data.split('/')[1])]}</div>
                    </div>
                    <div className="flex flex-col items-center justify-around">
                        <div className="flex items-center gap-1">
                            <img className="h-5" src="https://cdn-icons-png.flaticon.com/512/151/151770.png" />
                            <div className="text-xl">{props.role.horaInicio}</div>
                        </div>
                        <div className="flex items-center text-3xl">R${props.role.valor}</div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default Cartao